import type React from "react";
import type { RootState } from "../store";
import { fetchVendors } from "../store/features/vendorSlice";
import VendorTable from "../components/vendors/VendorTable";
import CreateVendorForm from "../components/vendors/CreateVendorForm";
import { createVendorApi, updateVendorApi } from "../api/vendorsApi";
import SimpleCrudPage from "../components/common/SimpleCrudPage";

const VendorsPage: React.FC = () => {
  return (
    <SimpleCrudPage
      titleTranslationKey="vendors.title"
      addButtonTranslationKey="Add Vendor"
      fetchAction={fetchVendors}
      createApi={createVendorApi}
      updateApi={updateVendorApi}
      selector={(state: RootState) => ({
        items: state.vendors.vendors,
        loading: state.vendors.loading,
      })}
      createErrorContext="createVendor"
      updateErrorContext="updateVendor"
      createSuccessMessage="Vendor created successfully"
      updateSuccessMessage="Vendor updated successfully"
      TableComponent={VendorTable}
      FormComponent={CreateVendorForm}
    />
  );
};

export default VendorsPage;
